import { useEffect, useState } from 'react';
import { useApi, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';

interface UseIsAdminResult {
  isAdmin: boolean;
  loading: boolean;
}

export function useIsAdmin(): UseIsAdminResult {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const base = await discoveryApi.getBaseUrl('aws-genai');
        const res = await fetchApi.fetch(`${base}/admin/me`);
        if (!res.ok) {
          if (!cancelled) setIsAdmin(false);
          return;
        }
        const body = await res.json();
        if (!cancelled) setIsAdmin(body.isAdmin === true);
      } catch {
        if (!cancelled) setIsAdmin(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    check();
    return () => { cancelled = true; };
  }, [discoveryApi, fetchApi]);

  return { isAdmin, loading };
}
